var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',_vm._l((_vm.value),function(assignment){return _c('div',{key:`${assignment.id}`},[_c('Assignment',{attrs:{"activity":assignment.activity,"resource-type":assignment.resourceType,"unit":assignment.unit}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }